// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9682) return "static/chunks/17dac012.5020a76b129a7328.js";
	if (chunkId === 2356) return "static/chunks/2356.bde24e1c3c4ba58f.js";
	if (chunkId === 1981) return "static/chunks/1981.b61f67c401ac991e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1631":"c2d7b96e","3692":"63b376ce"}[chunkId] || chunkId) + "-" + {"380":"08ee7293d33132f1","413":"1ed2b6b14e7028f2","1294":"d23cac8d398c9fa1","1631":"8ec265c68888ca63","3692":"d1e7d18b6b8a4494","5212":"cbfff49aaa3d74d2","7446":"bcdb2e161fc6da85","8880":"9edc95fb78aa192f","9351":"206a443284e1e619"}[chunkId] + ".js";
};